import { Schema, ArraySchema } from 'yup';

export function isArraySchema(schema: Schema<any>): schema is ArraySchema<any> {
  return schema.describe().type === 'array';
}
